import React from 'react';
import { Box, Typography } from '@material-ui/core';
import type { RetainedBeaconEligibility } from '@/hooks/useRetainedBeaconDischarge';
import { useScope } from '@/hooks/useScope';

interface Props {
  eligibility?: RetainedBeaconEligibility | null;
}

export function formatRetainedScheduledStart(value?: string | null, timeZone?: string) {
  if (!value) return null;
  return new Intl.DateTimeFormat('en-US', {
    timeZone,
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function RetainedBeaconDischargeChoice({ eligibility }: Props) {
  const scope = useScope();
  const hospitalTimeZone = scope?.hospital?.timezone?.id ?? 'UTC';
  const scheduledStart = formatRetainedScheduledStart(eligibility?.scheduledStart, hospitalTimeZone);

  return (
    <Box>
      <Typography>Are you sure you want to discharge this patient?</Typography>
      {scheduledStart && (
        <Typography variant="body2" style={{ marginTop: 12 }}>
          This patient has another scheduled procedure: {scheduledStart}
        </Typography>
      )}
      <Typography variant="body2" style={{ marginTop: 8 }}>
        Choose “Discharge and keep beacon” only when the patient will keep the beacon while remaining in the hospital.
      </Typography>
    </Box>
  );
}
